<template>
  <forgot-password-layout>
    <template slot="main">
      <section>
        <h1>{{ $_getTranslations.visitor_forgot_password_2_title }}</h1>

        <read-only-stepper-header :total-steps="3" :active-step="2"></read-only-stepper-header>

        <img src="/static/images/forgot_pin_icon.svg" class="register_mobile" alt="mobile image"/>

        <p>{{ $_getTranslations.visitor_forgot_password_2_description }}</p>

        <base-digit-form-input
          :model-value="formValues.pin"
          :label="$_getTranslations.visitor_forgot_password_input_label_four_digit_code"
          :invalid="pinInputValidationConfiguration.invalid"
          :max-length="maximumDigitsPinLength"
          @update:modelValue="handlePinChange"
        ></base-digit-form-input>

        <div v-if="pinInputValidationConfiguration.invalid" class="error_text">
          {{ pinInputValidationConfiguration.message }}
        </div>

        <img src="/static/images/info.svg" class="info_stetement"/>

        <p> {{ $_getTranslations.visitor_forgot_password_2_hint_pin }}</p>

        <base-button
          :disabled="isSubmitButtonDisabled"
          container-class="continue"
          @button:click.prevent="handleSubmit"
        >
          {{ $_getTranslations.visitor_forgot_password_button_continue }}
        </base-button>
      </section>
    </template>
  </forgot-password-layout>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import BaseDigitFormInput from '../../common/formInput/BaseDigitFormInput'
import BaseButton from '../../common/button/BaseButton'
import ReadOnlyStepperHeader from '../../common/header/ReadOnlyStepperHeader'
import ForgotPasswordLayout from './ForgotPasswordLayout'
import translationMixin from '../../../common/mixins/translation'
import {getApiResponseErrorMessage} from '../../../helpers/api'
import {apiResponseTypeEnum} from '../../../constants/api'
import {forgotPasswordErrorMessagesPerResponseType} from '../../../constants/forgotPassword'

const validationRegexPin = /^[0-9]{0,8}$/

export default {
  components: {
    BaseDigitFormInput,
    BaseButton,
    ReadOnlyStepperHeader,
    ForgotPasswordLayout
  },
  mixins: [
    translationMixin
  ],
  data () {
    return {
      formValues: {pin: ''},
      pinInputValidationConfiguration: {invalid: false, message: ''}
    }
  },
  methods: {
    ...mapMutations('profile', [
      'setHashedPassForForgotPass'
    ]),
    validateForm () { // not used
      this.pinInputValidationConfiguration.invalid = !this.formValues.pin.match(validationRegexPin)

      if (this.pinInputValidationConfiguration.invalid) {
        this.pinInputValidationConfiguration.message = this.$_translateTextByOperator({key: 'visitor_forgot_password_error_verification_code_invalid'})
      }
    },
    resetErrors () {
      if (this.pinInputValidationConfiguration.invalid) {
        this.pinInputValidationConfiguration.invalid = false
        this.pinInputValidationConfiguration.message = ''
      }
    },
    handlePinChange (value) {
      this.formValues.pin = value

      if (this.pinInputValidationConfiguration.invalid) {
        this.resetErrors()
      }
    },
    handleSubmit () {
      this.resetErrors()

      this.$axios.get(`api/verifyPinForForgotPassword?msisdn=${this.forgotPasswordInfo}&pin=${this.formValues.pin}`).then(response => {
        const {responseEnum, data: responseData} = response.data

        if (responseEnum === apiResponseTypeEnum.OPERATION_SUCCESS) {
          this.setHashedPassForForgotPass(responseData.hashedPass)

          this.$router.push('forgotPassword3')
        } else {
          this.pinInputValidationConfiguration.message = this.$_translateTextByOperator({
            key: getApiResponseErrorMessage(responseEnum, forgotPasswordErrorMessagesPerResponseType)
          })
          this.pinInputValidationConfiguration.invalid = true
        }
      })
    }
  },
  computed: {
    ...mapState('profile', [
      'forgotPasswordInfo'
    ]),
    ...mapState('common', [
      'maximumDigitsPinLength'
    ]),
    isSubmitButtonDisabled () {
      return !this.formValues.pin ||
        (this.formValues.pin.length < this.maximumDigitsPinLength)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPassword2.vue